$(document).ready(function(){
  setTimeout(function(){  
    $('.recently-viewed .grid__item_box').each(function(index, item){
      var attt =  $(item).attr("hide");
      
      // Check if the attribute exists
      if (typeof attt !== 'undefined' && attt === '') {
        $(item).remove();
      }
    });
  },300);  
  
  setTimeout(function(){
    var length = $('.recently-viewed .grid__item_box').length;
    console.log(length); 
    // alert(length);
    if(length === 0){
      $('.recent-view-main').remove();
    }
  }, 500); 
  setTimeout(function(){
  $(".recently-viewed").slick({
   slidesToShow: 4,
   infinite:false,
   slidesToScroll: 1,
   autoplay: false,
   autoplaySpeed: 2000,
   arrows: false,
   dots: true,
    responsive: [
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          arrows: false,
          slidesToScroll: 1
        }
      }
    ]
  });
  },600);  
});